const API_BASE_URL = "https://vedarambh-backend.onrender.com";

export default API_BASE_URL;
